import React from "react";
import { ThumbPostPreview } from "./ThumbPostPreview";
import { Pagination } from "./Pagination";

export const GameCategoryContent = ({ data }) => {
  return (
    <>
      <div className="section-title">{data.category.name}</div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5  gap-4">
        {data.category.posts.map((node) => {
          return <ThumbPostPreview key={node.uri} data={node} />;
        })}
      </div>
      <Pagination data={data} />
    </>
  );
};
